import styled from 'styled-components/native';

import blockedImage from '../images/blocked.png';

export default styled.Image.attrs({ source: blockedImage })`
  height: 48px;
  width: 48px;
  margin-bottom: 20px;
`;
